import {
  GenericForm,
  GenericFormLogic,
  giftcardNumberFormLogic,
  giftcardPinFormLogic,
} from "../../../Common";

export interface ApplyAGiftcardForm extends GenericForm {
  giftcardNumber?: string;
  giftcardNumberError?: string;

  giftcardPin?: string;
  giftcardPinError?: string;
}

export const initialApplyAGiftcardForm = (): ApplyAGiftcardForm => ({});

export interface ApplyAGiftcardFormApp {}

export const ApplyAGiftcardFormLogic: GenericFormLogic<
  ApplyAGiftcardForm,
  ApplyAGiftcardFormApp
> = {
  giftcardNumber: giftcardNumberFormLogic({ required: true }),
  giftcardPin: giftcardPinFormLogic({ required: true }),
} as const;
